// removed by extract-text-webpack-plugin
module.exports = {"box":"_-pages-CapacityRatio-compontents-RatioTable-searchLoad-box","wrapperButton":"_-pages-CapacityRatio-compontents-RatioTable-searchLoad-wrapperButton","button":"_-pages-CapacityRatio-compontents-RatioTable-searchLoad-button","dialog":"_-pages-CapacityRatio-compontents-RatioTable-searchLoad-dialog"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/CapacityRatio/compontents/RatioTable/searchLoad/index.css
// module id = 1860
// module chunks = 0